import React from "react";

import Pagetitle from "../elements/Pagetitle";
import Portfolio from "../elements/Portfolio";
import { useGlobalContext } from "../../context/global";

function Works() {
  const { data } = useGlobalContext();
  const { _projects: allData = [] } = data || {};
  return (
    <section id="works">
      <div className="container">
        <Pagetitle title="Projects" />
        <div className="row portfolio-wrapper">
          {allData.map((item) => (
            <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
              <Portfolio portfolio={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Works;
